import React from "react";
import AboutCompanyDescription from "@/features/about-company-page/components/about-company-description/AboutCompanyDescription";
import AboutCompanyNumbers from "@/features/about-company-page/components/about-company-numbers/AboutCompanyNumbers";
import AboutCompanySpecial from "@/features/about-company-page/components/about-company-special/AboutCompanySpecial";
import AboutCompanyBackground from "@/common/components/custom-background/about-company-background/AboutCompanyBackground";

import styles from "@/styles/page.module.scss";

const AboutPage = () => {
  return (
    <div className={styles.aboutCompanyWrapper}>
      <AboutCompanyDescription />
      <AboutCompanyNumbers />
      <AboutCompanySpecial />
      <AboutCompanyBackground />
    </div>
  );
};

export default AboutPage;
